module.exports = __webpack_public_path__ + "assets/img/m11.cacdf7a5.png";